import React from "react";
import useSearch from "./useSearch";
import { useForm } from "react-hook-form";
import { clearSearchParams, clearStoredParams, getInitialParams, saveParams } from "./utils";
import { eventButtonType } from "../../../common/types/common";

type visibilitySelectorType = { key: string; visibleOn: boolean };

interface SearchBarProps {
	formId: string;
	initialValues: { [key: string]: string | string[] };
	saveFormToLocalStorage: boolean;
	searchComponents: React.ReactElement<{ name: string }>[];
	searchComponentsVisibility?: visibilitySelectorType[];
	title: string;
}

export function SearchBar({
	formId,
	initialValues,
	saveFormToLocalStorage = false,
	searchComponents,
	searchComponentsVisibility,
	title,
}: SearchBarProps) {
	const { onSearch, onClearSearch } = useSearch();
	const { control, handleSubmit, reset } = useForm({
		defaultValues: Object.assign(
			{},
			initialValues,
			getInitialParams(saveFormToLocalStorage),
		),
	});

	const handleClearSearch = (e: eventButtonType) => {
		reset(initialValues);
		clearStoredParams();
		clearSearchParams();
		onClearSearch(e);
	};

	return (
		<form
			id={formId}
			aria-label={title}
			onSubmit={handleSubmit((data) => {
				saveParams(data);
				onSearch(data);
			})}
			className="searchbar-form form-inline"
		>
			{searchComponents.map((element) => {
				const id = element?.props?.name;

				if (
					searchComponentsVisibility?.find(
						(item) => item.key === id && !item.visibleOn,
					)
				) {
					return null;
				}

				return React.cloneElement(element, {
					// @ts-ignore
					control,
				});
			})}
			<div className="btn-toolbar gap-3">
				<button type="submit" form={formId} className="btn btn-primary">
					Search
				</button>
				<button
					type="button"
					className="btn btn-default"
					onClick={handleClearSearch}
				>
					Clear
				</button>
			</div>
		</form>
	);
}
